
import DisintergrationReasonDialogContent from "./disintergration-reason-dialog-content.vue";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog, DisintergrationReasonDialogContent },
  props: {
    dialog: false,
    loading: false
  }
};
